import communicative from "../../../assets/img/communicative.svg"
import teamwork from "../../../assets/img/teamwork.svg"
import creative from "../../../assets/img/creative.svg"
import adaptability from "../../../assets/img/adaptability.svg"
import openminded from "../../../assets/img/openminded.svg"
import passionate from "../../../assets/img/passionate.svg"

export default {
    communicative,
    teamwork,
    creative,
    adaptability,
    openminded,
    passionate
}
